import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';

import { ListingService } from '../../../../services/listing.service';
import { StatusColors } from '../../../../lists/listing-fields';
import { RecordService } from '../../../../services/record.service';
import { LocalStorageService } from '../../../../services/local-storage.service';
import { NotificationService } from '../../../../services/notification.service';
import { ViewService } from '../../../../services/view.service';
import { ClientStoreService } from '../../../../services/client-store.service';
import { filter, switchMap, tap } from 'rxjs/operators';
import { blank, filled, isId, observe } from '../../../utils/common';
import { defer, EMPTY } from 'rxjs';
import { safely_parse_json } from '../../../utils/common';
import { translate_period } from '../../../../module/checklists';
import { LooseObject } from '../../../../objects/loose-object';
import { get } from 'lodash-es';

@Component({
  selector: 'app-checklists',
  templateUrl: './checklists.component.html',
  styleUrls: ['./checklists.component.scss'],
  providers: [ListingService]
})
export class ChecklistsComponent implements OnInit {
  @Input() strRecordId: string;

  /**
   * Where will this module be placed? Data fetched for the
   * widget will be related to the given record (module + record id)
   * so this should always be set correctly.
   */
  @Input() strModule: string;

  @Output() refreshJobAssets = new EventEmitter<any>();

  public arLinkedChecklist = [];
  public objColors = new StatusColors;
  public bLoader = false;
  public bProcessed: boolean = true;

  constructor (
    public clientStoreService: ClientStoreService,
    public route: ActivatedRoute,
    public recordService: RecordService,
    public translateService: TranslateService,
    public listingService: ListingService,
    public viewService: ViewService,
    private notifService: NotificationService,
    protected localStorageService: LocalStorageService
  ) {}

  ngOnInit() {
    this.fetchData('default');
  }

    convertChecklistType(type) {
        switch(type) {
          case 'job' :
            return "job_checklist"
          case 'opportunity' :
            return "quote_checklist";
          case 'asset' :
            return "asset_checklist";
        }
    }

    /**
     * Fetch the list of linked checklist responses.
     * @param strPage - what page is currently to be viewed.
     */
    fetchData(strPage) {
      const recordView = this.viewService.getViewRecord();
      let objOption: LooseObject = {};
      let objPagination = this.listingService.beforeFetching(strPage);

      this.bLoader = false;

      if (this.strRecordId) {
        let strFilterKey: string = this.strModule === 'opportunities' ? 'opportunity_id' : 'job_id';
        let objFilter = {
          [strFilterKey]: this.strRecordId,
          'order_by': {id: 'created_at', sort: 'desc'},
        };

        if (
          this.strModule == 'jobs'
          && filled(get(recordView, 'parent_id'))
          && filled(get(recordView, 'parent_client_id'))
        ) {
          objFilter['job_id'] = recordView.parent_id
          objOption.other_client_id = recordView.parent_client_id
        }

        console.log(objFilter);
        this.listingService.fetchData(
          JSON.stringify(objPagination['objPage']),
          'checklist_responses',
          JSON.stringify(objFilter),
          null,
          objOption
        ).subscribe(response => {
            this.bLoader = true;
            this.arLinkedChecklist = response['data'];
            this.listingService.afterFetching(response, strPage);
        });
      } else {
        this.notifService.notifyWarning('error_in_fetching_checklist');
        this.arLinkedChecklist = [];
        this.bLoader = true;
      }
    }

    deleteRecord = (id: string) => observe({
      observable: () => defer(() => {
        if (blank(id) || ! isId(id)) {
          return EMPTY;
        }

        return this.notifService.sendConfirmation('confirm_delete_checklist_response', 'warning');
      })
      .pipe(
        filter((confirm) => confirm && confirm.answer),
        switchMap(() => this.recordService.deleteRecord('checklist_responses', id)),
        filter((response) => response.status == 200),
        tap(() => this.fetchData('reload')),
        tap(() => this.refreshJobAssets.emit({ widget: 'assets' })),
        tap(() => this.notifService.notifySuccess('Record deleted successfully')),
      )
    })
    .subscribe();

    convertPeriod(period): string {
      const periods: string[] = safely_parse_json(period, {
        fallback: () => [],
      });

      const translated: string[] = [];

      for (const period of periods) {
        translated.push(translate_period(period, {
          translator: this.translateService,
        }));
      }

      return translated.join(', ');
    }

  /**
   * Handles refresh list event
   *
   * @returns {void}
   */
  onRefresh(): void {
    this.arLinkedChecklist = []; // clear list
    this.fetchData('default');
  }

  ngOnChanges(): void {
    this.onRefresh();
  }

  onLinkComplete = () => this.fetchData('default');

  onResponseComplete = () => this.fetchData('default');
}
